import useMenu from '../../../hooks/menu/useMenu';
import collect from 'collect.js';
import useGetCompanyMenusApi from '../../../hooks/api/companies/useGetCompanyMenusApi';
import { useCallback } from 'react';

const useValidateOfferProducts = () => {
  const { compileProduct } = useMenu();
  const { data: menusData } = useGetCompanyMenusApi();
  const validate = useCallback(
    (productId: number): boolean => {
      const entry = compileProduct(productId);

      if (!entry || !entry.is_available) {
        return false;
      }

      const categories = collect(entry?.category_ids).map((id) => menusData?.categories[id]);
      const menus = collect(menusData?.menus).whereIn('id', categories.pluck('menu_ids').flatten().toArray());

      return !!menus.count();
    },
    [menusData],
  );

  return validate;
};

export default useValidateOfferProducts;
